import { atom } from 'jotai';
import mobile from 'is-mobile';

const isMobileAtom = atom(mobile());
const isVideoUploadedAtom = atom(false);
// Bumped when a report is handled: the open reports count of the menu is read again.
const reportsUpdatedAtom = atom(0);
// A video picked from "Publier" in the menu: Mes vidéos opens its upload popup with it.
const pickedVideoFileAtom = atom<File | null>(null);
// The notifications panel is open: the side menu highlights its item instead of the page.
const notificationsOpenAtom = atom(false);

export {
  isMobileAtom,
  isVideoUploadedAtom,
  notificationsOpenAtom,
  pickedVideoFileAtom,
  reportsUpdatedAtom,
}
